import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=527b92ec&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=527b92ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b92ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('527b92ec')) {
      api.createRecord('527b92ec', component.options)
    } else {
      api.reload('527b92ec', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=527b92ec&scoped=true&", function () {
      api.rerender('527b92ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/freelance/detail.vue"
export default component.exports